import { getRawFieldErrors } from "@/components/FormEngine/helpers/buildErrors";
import { buildFormField } from "@/components/FormEngine/helpers/buildField";
import { buildFormHierarchy } from "@/components/FormEngine/helpers/buildFormHierarchy";
import { findLeafObjects } from "@/components/FormEngine/helpers/findLeafObjects";

import { FormField, InvalidField, ParsedForm, RawField } from "./types";

const EMPTY_RESULT: ParsedForm = { steps: new Map(), invalidFields: [] };

export const parseRawForm = (json: JSON | null | undefined): ParsedForm => {
  if (!json) return EMPTY_RESULT;

  const validFields: FormField[] = [];
  const invalidFields: InvalidField[] = [];

  const leafs = findLeafObjects(json);

  for (const { data, path } of leafs) {
    const errors = getRawFieldErrors(data);

    if (errors.length > 0) {
      invalidFields.push({
        id: path.join("."),
        raw: data as RawField,
        path,
        errors,
      });
    } else {
      validFields.push(buildFormField(data, path));
    }
  }

  return {
    steps: buildFormHierarchy(validFields),
    invalidFields,
  };
};
